import { render, staticRenderFns } from "./ExerciseLogicId.vue?vue&type=template&id=d3281470&"
import script from "./ExerciseLogicId.vue?vue&type=script&lang=js&"
export * from "./ExerciseLogicId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports